<template>
  <section
    :class="`grid grid-cols-12 gap-3 items-center border-b-2 border-b-gray-100 p-5 hover:bg-blue-50  overflow-hidden`"
  >
    <div class="col-span-12 md:col-span-10" v-auto-animate="{ duration: 1000 }">
      <div class="flex items-center flex-wrap gap-5">
        <div class="flex justify-center">
          <v-icon
            :name="materialsUtils.getIcon(data.file?.mimetype)"
            class="text-h-primary-500"
            :scale="1.3"
          />
        </div>
        <div class="flex flex-col">
          <p class="text-lg font-bold text-gray-800 mb-2">
            {{ data.name }}
          </p>
          <div
            class="flex flex-wrap gap-3 md:divide-x divide-gray-500 text-gray-500 text-sm"
          >
            <span>
              {{ $t("objects.inputs.classification") }}:
              {{ serviceChapter.getMaterialGroupName(data.learningGroupType) }}
            </span>

            <TagMaterials :material="data" />

            <div v-if="statusObject(data.file?.status) != 'DONE'">
              <p class="ml-2 text-sm">
                {{ statusObject(data.file?.status) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-span-12 md:col-span-2">
      <div
        class="flex items-center justify-end gap-5"
        v-if="role === 'TEACHER'"
      >
        <v-icon
          name="md-edit"
          class="text-h-primary-500 hover:scale-110 cursor-pointer"
          @click="onEdit()"
        />
        <v-icon
          v-if="loading && currentItem === data"
          name="ri-loader-5-fill"
          class="text-red-700 animate-spin"
        />
        <v-icon
          v-else
          name="md-delete"
          class="text-red-700 hover:scale-110 cursor-pointer"
          :disabled="loading"
          @click="onDelete(data)"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Material } from "@/models/material.model";
import { MaterialsUtils } from "@/utils/materials.util";
import { ChaptersService } from "@/views/Chapters/chapters.service";
import { defineComponent } from "@vue/runtime-core";
import { MaterialsService } from "../materials.service";

export default defineComponent({
  name: "listContent",
  emits: ["onDelete", "onEdit", "update:loader"],
  computed: {
    serviceChapter(): ChaptersService {
      return new ChaptersService();
    },
    service(): MaterialsService {
      return new MaterialsService();
    },
    materialsUtils(): MaterialsUtils {
      return new MaterialsUtils();
    },
    loading: {
      get() {
        return this.loader;
      },
      set(value) {
        this.$emit("update:loader", value);
      },
    },
  },
  props: {
    data: {
      type: Object,
      default: new Material(),
    },
    role: [String],
    index: [Number],
    allData: [Array],
    loader: { type: Boolean, default: false },
  },
  data() {
    return {
      currentItem: {} as Material,
    };
  },
  methods: {
    onEdit(): void {
      this.$emit("onEdit");
    },
    onDelete(item: any): void {
      this.$emit("onDelete");
      this.currentItem = item;
    },
    statusObject(status: string): string {
      let result = "";
      if (status === "DONE") {
        result = status;
      } else if (status === "WAITING") {
        result = this.$t("labels.generic", {
          pt: "Processando...",
          en: "Processing...",
        });
      } else if (status === "FAIL") {
        result = this.$t("labels.generic", {
          pt: "Falha",
          en: "Fail",
        });
      }
      return result;
    },
  },
});
</script>
